import { ReactNode } from 'react';
import { theme, Typography } from 'antd';

const { Text } = Typography;

interface PageHeaderProps {
  title: string;
  /**
   * @deprecated Page-level subtitles are removed for strict title-only parity with
   * the Vendor/Customer pages. The prop is retained for API compatibility (no
   * breaking change) but should no longer be passed at list/admin/detail call
   * sites — when omitted, the header renders cleanly as title-only.
   */
  subtitle?: string;
  extra?: ReactNode;
  className?: string;
}

/**
 * Consistent page title with optional extra content.
 * @param title - Main page title
 * @param subtitle - @deprecated title-only is the standard; do not pass at call sites
 * @param extra - Optional content to display on the right (e.g., buttons)
 * @param className - Additional CSS classes
 */
const PageHeader = ({
  title,
  subtitle,
  extra,
  className = '',
}: PageHeaderProps) => {
  const { token } = theme.useToken();

  return (
    <div
      className={`tw-mb-6 tw-flex tw-items-center tw-justify-between ${className}`}
    >
      <div>
        <h1
          style={{
            fontSize: token.fontSizeHeading2,
            fontWeight: token.fontWeightStrong,
            marginBottom: subtitle ? token.marginXXS : 0,
          }}
        >
          {title}
        </h1>
        {subtitle && (
          <Text type="secondary" style={{ fontSize: token.fontSize }}>
            {subtitle}
          </Text>
        )}
      </div>
      {extra && <div>{extra}</div>}
    </div>
  );
};

export default PageHeader;
